"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAccessApi = void 0;
const fetch_1 = require("./fetch");
const createAccessApi = (options) => {
    const fetchFn = (0, fetch_1.fetchFactory)(options);
    return () => fetchFn({
        method: "GET",
        path: ["access"],
        qs: null,
    });
};
exports.createAccessApi = createAccessApi;
//# sourceMappingURL=accessApi.js.map